export type VersionTemplateFormFields = {
  inputs: Record<string, boolean | string | number | null>;
  name: string;
  description: string;
  space: string;
  versionId?: string;
};

/**
 * The action a user intends for a secret field during edit mode.
 *
 * - KEEP:   Leave the secret untouched (default). Field is omitted from the payload.
 * - CHANGE: Replace with a new value the user types. Field is sent with the new value.
 * - RESET:  Set to an empty value "". Field exists but is blank.
 * - DELETE: Remove the field entirely. Field is omitted from the payload (no longer exists).
 */
export enum SecretFieldAction {
  KEEP = "keep",
  CHANGE = "change",
  RESET = "reset",
  DELETE = "delete",
}

export type SecretFieldsState = {
  /** Map of input ID → the action the user chose. Missing keys default to KEEP. */
  fieldActions: Map<string, SecretFieldAction>;
  /** Set the action for a secret field */
  setAction: (inputId: string, action: SecretFieldAction) => void;
  /** Set of secret input IDs that have existing values in the deployment */
  existingSecretIds: Set<string>;
};
